import { Typography } from "@braintrust/braintrust-ui-components";
import { useMediaQuery } from "@braintrust/braintrust-ui-components";

type PaymentMethodMaskedNumberProps = {
  last4: string | null;
};

export const PaymentMethodMaskedNumber = ({
  last4,
}: PaymentMethodMaskedNumberProps) => {
  const isSmall = useMediaQuery("sm");

  return (
    <Typography component="span" size={isSmall ? "small" : "medium"}>
      {isSmall ? (
        <>&bull; &bull; &bull; &bull;&nbsp;&nbsp;</>
      ) : (
        <>
          &bull; &bull; &bull; &bull;&nbsp;&nbsp; &bull; &bull; &bull;
          &bull;&nbsp;&nbsp; &bull; &bull; &bull; &bull;&nbsp;&nbsp;
        </>
      )}
      {last4}
    </Typography>
  );
};
